import { PipelineContext34fsb0mycu471 as PipelineContext } from './PipelineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *proceedLoop($this, $completion) {
  $l$loop_0: do {
    var index = $this.w4q_1;
    if (index === -1) {
      break $l$loop_0;
    }
    var interceptors = $this.t4q_1;
    if (index >= interceptors.q2()) {
      $this.x4q();
      break $l$loop_0;
    }
    var executeInterceptor = interceptors.r2(index);
    $this.w4q_1 = index + 1 | 0;
    yield* executeInterceptor($this, $this.v4q_1, $completion);
  }
   while (true);
  return $this.v4q_1;
}
var DebugPipelineContextClass;
function DebugPipelineContext() {
  if (DebugPipelineContextClass === VOID) {
    class $ extends PipelineContext() {
      constructor(context, interceptors, subject, coroutineContext) {
        super(context);
        this.t4q_1 = interceptors;
        this.u4q_1 = coroutineContext;
        this.v4q_1 = subject;
        this.w4q_1 = 0;
      }
      sv() {
        return this.u4q_1;
      }
      y4q() {
        return this.v4q_1;
      }
      x4q() {
        this.w4q_1 = -1;
      }
      *z4q(subject, $completion) {
        this.v4q_1 = subject;
        return yield* this.a4r($completion);
      }
      *a4r($completion) {
        var index = this.w4q_1;
        if (index < 0)
          return this.v4q_1;
        if (index >= this.t4q_1.q2()) {
          this.x4q();
          return this.v4q_1;
        }
        return yield* /*#__NOINLINE__*/proceedLoop(this, $completion);
      }
      *b4r(initial, $completion) {
        this.w4q_1 = 0;
        this.v4q_1 = initial;
        return yield* this.a4r($completion);
      }
    }
    initMetadataForClass($, 'DebugPipelineContext', VOID, VOID, VOID, [1, 0]);
    DebugPipelineContextClass = $;
  }
  return DebugPipelineContextClass;
}
//region block: exports
export {
  DebugPipelineContext as DebugPipelineContext2zfnr2i0vcihk,
};
//endregion

//# sourceMappingURL=DebugPipelineContext.mjs.map
